/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, boxShadow, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : CODE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	code: {
		'& #content': {
			paddingTop: `${pxToEm(30)} !important`,
		},
		'& .title': {
			'& h2': { fontSize: pxToEm(22) }
		},
		'& .tabs': {
			maxWidth: pxToEm(935),
			margin: '0 auto',
			'& .tabhead': {
				opacity: '0',
				animationDuration: '.2s',
	            animationFillMode: 'forwards',
	            transition: 'box-shadow .2s linear 0s',
	            '&:hover': { extend: boxShadow.grey },
				'&:nth-child(1)': { animationName: 'fadeInDown', animationDelay: '.2s', transform: 'translateY(-200%)' },
				'&:nth-child(2)': { animationName: 'fadeInDown', animationDelay: '.3s', transform: 'translateY(-200%)' },
				'&:nth-child(3)': { animationName: 'fadeInDown', animationDelay: '.4s', transform: 'translateY(-200%)' },
				'&:nth-child(4)': { animationName: 'fadeInDown', animationDelay: '.5s', transform: 'translateY(-200%)' },
				'&:nth-child(5)': { animationName: 'fadeInDown', animationDelay: '.6s', transform: 'translateY(-200%)' },
				'&:nth-child(6)': { animationName: 'fadeInDown', animationDelay: '.7s', transform: 'translateY(-200%)' },
				'&:nth-child(7)': { animationName: 'fadeInDown', animationDelay: '.8s', transform: 'translateY(-200%)' },
			},
			'& .tabbody': { 
				animationName: 'fadeInUp',
				animationDuration: '.2s',
	            animationFillMode: 'forwards',
	            animationDelay: '.4s',
	            opacity: '0',
	            transform: 'translateY(0%)'
			}
		},
		// ctas
		'& .controls': {
			maxWidth: pxToEm(935),
			margin: '20px auto 0',
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			'& .ctas': {
				flexWrap: 'wrap'
			},
            '& .button': {
            	marginLeft: pxToEm(10),
            	marginBottom: pxToEm(10),
            	animationName: 'fadeIn',
				animationDuration: '.2s',
	            animationFillMode: 'forwards',
	            opacity: '0',
	            '&.name-preview': { animationDelay: '1.1s', width: pxToEm(156) },
	            '&.name-createembed': { animationDelay: '1.3s' },
	            '&.name-returntolibrary': { animationDelay: '1.5s' },
	            '&:first-child': { marginLeft: '0' },
            }
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thinnest]: { 
        code: {
        	'& .controls': {
        		flexDirection: 'column',
        		'& .button': {
        			flex: '1',
        			'&.name-preview': { width: '100%' }
        		}
        	}
        }
    }
});